import _ from "lodash";

export default {
  loggedIn(state) {
    return Boolean(state.token);
  },
  client(state) {
    if (state.client === null && sessionStorage.client) {
      state.client = JSON.parse(sessionStorage.client);
    }
    return state.client;
  },

  remainingPayment(state) {
    const result =
      state.client.clientGroup[0].contracts[0].recommendedPaymentSumThisMonth -
      state.client.clientGroup[0].contracts[0].paymentSumThisMonthNew;
    if (result < 0) return 0;
    return result;
  },

  sumNextPayments(state) {
    let payments = 0;
    state.client.clientGroup[0].services.forEach((service) => {
      let dateCondition = true;
      if (Object.hasOwn(service, "edate") && service.edate) {
        dateCondition = new Date(service.edate) > new Date();
      }
      if (
        service.active !== "A" &&
        service.active !== "F" &&
        Object.hasOwn(service, "abonPayment") &&
        dateCondition
      ) {
        payments += service.abonPayment;
        if (service.additional) {
          service.additional.forEach((subservice) => {
            if (
              subservice.active !== "A" &&
              subservice.active !== "F" &&
              Object.hasOwn(subservice, "abonPayment")
            )
              payments += subservice.abonPayment;
          });
        }
      }
    });
    return payments;
  },

  globalError(state) {
    if (state.globalError) {
      return _.toString(state.globalError);
    }
    if (Boolean(state.token) && (!state.client || !state.client.billing)) {
      return "Информация о клиенте недоступна!";
    }
    return null;
  },
};
